// src/components/Profile/ProfileSidebar.js
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import Loader from './Loader';

const ProfileSidebar = ({ isOpen, onClose }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = Cookies.get("ecom_user_token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/buyer/get-by-id`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUserData(response?.data?.user);
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Close sidebar when a link is clicked on mobile
  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      onClose();
    }
  };

  // if (loading) return <Loader />;

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={onClose}
        ></div>
      )}
      
      <div className={`fixed md:static inset-y-0 left-0 z-50 w-64 bg-white rounded-xl shadow-md overflow-hidden transform transition-transform duration-300 ease-in-out md:translate-x-0 md:shadow-none md:rounded-none ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="p-6 h-full overflow-y-auto">
          <div className="flex justify-between items-center mb-4 md:hidden">
            <h3 className="text-lg font-semibold">Menu</h3>
            <button 
              onClick={onClose}
              className="p-2 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="flex flex-col items-center border-b border-gray-100 pb-6">
            <h2 className="mt-4 text-xl font-semibold text-gray-800">{userData?.name}</h2>
            <p className="text-gray-600 text-sm">{userData?.email}</p>
            <p className="text-gray-600 text-sm mt-1">{userData?.phone}</p>
          </div>

          <nav className="mt-8">
            <Link
              to="/profile"
              onClick={handleLinkClick}
              className={`w-full text-left px-4 py-3 rounded-lg mb-2 flex items-center ${
                location.pathname === '/profile' ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              Profile
            </Link>
            <Link
              to="/profile/addresses"
              onClick={handleLinkClick}
              className={`w-full text-left px-4 py-3 rounded-lg mb-2 flex items-center ${
                location.pathname.includes('addresses') ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              Addresses
            </Link>
            <Link
              to="/profile/orders"
              onClick={handleLinkClick}
              className={`w-full text-left px-4 py-3 rounded-lg mb-2 flex items-center ${
                location.pathname.includes('orders') ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              My Orders
            </Link>
             <Link
              to="/profile/wallet"
              onClick={handleLinkClick}
              className={`w-full text-left px-4 py-3 rounded-lg mb-2 flex items-center ${
                location.pathname.includes('wallet') ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              My Wallet
            </Link>
            <Link
              to="/profile/bank-account"
              onClick={handleLinkClick}
              className={`w-full text-left px-4 py-3 rounded-lg mb-2 flex items-center ${
                location.pathname.includes('bank-account') ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              My Bank Account
            </Link>
          </nav>
        </div>
      </div>
    </>
  );
};

export default ProfileSidebar;